/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DataAutoCentred.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  justifyContent: "center",
  width: 'var(--width)',
minWidth: 'var(--minWidth)',
maxWidth: 'var(--maxWidth)',
height: 'var(--height)',
marginLeft: 'var(--marginLeft)',
marginRight: 'var(--marginRight)'})
styles.Text = css({label: 'Text',
  color: "#303030",
fontFamily: "WonderUnitSans",
fontSize: 8,
fontWeight: 500,
letterSpacing: 1,
textTransform: "uppercase",
marginBottom: 0,
  
transition: 'opacity 150ms ease-out, height 150ms ease-out 20ms',
willChange: 'opacity, height',
  opacity: 'var(--opacity)',
height: 'var(--height)'})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row"})
styles.Text1 = css({label: 'Text1',
  fontFamily: "WonderUnitSans",
letterSpacing: 0.3,
textOverflow: "ellipsis",
overflowX: "hidden",
  backgroundColor: 'var(--backgroundColor)',
color: 'var(--color)',
fontSize: 'var(--fontSize)',
fontWeight: 'var(--fontWeight)',
textTransform: 'var(--textTransform)',
whiteSpace: 'var(--whiteSpace)',
paddingLeft: 'var(--paddingLeft)'})
styles.Text2 = css({label: 'Text2',
  fontFamily: "WonderUnitSans",
letterSpacing: 0.3,
marginLeft: 8,
  backgroundColor: 'var(--backgroundColor)',
color: 'var(--color)',
fontSize: 'var(--fontSize)',
fontWeight: 'var(--fontWeight)',
textTransform: 'var(--textTransform)'})

export default function DataAutoCentred({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  width= "auto",
minWidth= "auto",
maxWidth= "25%",
height= 50,
marginLeft= 8,
marginRight= 0,
label= "",
backgroundColor= "transparent",
text,
color= "#303030",
fontSize= 14,
fontWeight= 400,
textTransform,
whiteSpace= "nowrap",
paddingLeft= 0,
additional= "",
isHovered
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="DataAutoCentred.Vertical"
 data-view-path={dataViewPath}
 style={{'--width': typeof width === 'number' ? `${width}px` : width,'--minWidth': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--maxWidth': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--height': typeof height === 'number' ? `${height}px` : height,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="DataAutoCentred.Text"
 data-view-path={dataViewPath}
 style={{'--opacity': isHovered ? 1 : 0,'--height': isHovered ? "15px" : "0px"}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
<div
 data-testid="DataAutoCentred.Horizontal"
 data-view-path={dataViewPath}
 className={`views-block ${styles.Horizontal}`}
>
<span
 data-testid="DataAutoCentred.Text:1"
 data-view-path={dataViewPath}
 style={{'--backgroundColor': backgroundColor,'--color': color,'--fontSize': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fontWeight': fontWeight,'--textTransform': textTransform,'--paddingLeft': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--whiteSpace': isHovered ? "wrap" : whiteSpace}}
 className={`views-text ${styles.Text1}`}
>
{!text ? "-" : text}
</span>
<span
 data-testid="DataAutoCentred.Text:2"
 data-view-path={dataViewPath}
 style={{'--backgroundColor': backgroundColor,'--color': color,'--fontSize': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fontWeight': fontWeight,'--textTransform': textTransform}}
 className={`views-text ${styles.Text2}`}
>
{additional}
</span>
</div>
</div>
{children}
</React.Fragment>)
}